const colors = ['#7CFFFE'];

export function formatPnl(input: number, { decimalPlaces = 1 } = {}) {
  const sign = input > 0 ? '+' : '';
  return `${sign}${input.toFixed(decimalPlaces)}%`;
}

export const chartOptions: ApexCharts.ApexOptions = {
  chart: {
    sparkline: {
      enabled: true,
    },
    animations: {
      enabled: false,
    },
  },
  xaxis: {
    type: 'datetime',
    tickAmount: 6,
  },
  colors,
  stroke: {
    width: 1,
    curve: 'smooth',
    fill: {
      type: 'gradient',
      colors: ['#71E8E7'],
      gradient: {
        gradientToColors: ['#2E85D3'],
      },
    },
  },

  fill: {
    type: 'gradient',
    // opacity: 0.43,
    gradient: {
      shadeIntensity: 1,

      colorStops: [
        {
          offset: 0,
          color: '#2E85D3',
          opacity: 0.43,
        },
        {
          offset: 90,
          color: 'rgba(46, 133, 211)',
          opacity: 0,
        },
      ],
    },
  },

  noData: {
    text: 'No data',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: -30,
    style: {
      color: '#646464',
    },
  },
  tooltip: {
    x: {
      format: 'dd/MM/yy',
    },
    y: {
      formatter: (value: number) => formatPnl(value, { decimalPlaces: 2 }),
    },
    marker: {
      show: false,
    },
    theme: false as unknown as string,
    cssClass: 'chart-tooltip',
    style: {
      fontFamily: '',
      fontSize: '',
    },
  },
};
